import React, { ReactNode } from 'react';
import { Accordion } from 'react-bootstrap';

interface Props {
	children: ReactNode;
	header?: ReactNode;
}

const InstructionsPanel = ({
	children,
	header = 'Instructions - Progress Saves Automatically',
}: Props) => {
	return (
		<Accordion className='instructions-panel mb-3' defaultActiveKey='0'>
			<Accordion.Item eventKey='0'>
				<Accordion.Header>{header}</Accordion.Header>
				<Accordion.Body>{children}</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
};

export default InstructionsPanel;
